<template>
  <div class="modal-card has-text-centered" style="width: auto">
    <!-- FLUJO ASYNC -->
    <template v-if="esAsync">
      <header class="modal-card-head">
        <p class="modal-card-title">Procesando entrega</p>
      </header>
      <section class="modal-card-body">
        <table class="table is-fullwidth">
          <tbody>
            <tr v-for="paso in pasosVisibles" :key="paso">
              <td style="width: 2rem; vertical-align: middle">
                <b-icon
                  v-if="estadoPasos[paso] === 'ok'"
                  icon="check-circle"
                  type="is-success"
                />
                <b-icon
                  v-else-if="estadoPasos[paso] === 'error'"
                  icon="alert-circle"
                  type="is-danger"
                />
                <b-icon
                  v-else-if="estadoPasos[paso] === 'loading'"
                  icon="loading"
                  custom-class="mdi-spin"
                  type="is-info"
                />
                <b-icon v-else icon="clock" pack="far" type="is-light" />
              </td>
              <td style="vertical-align: middle; text-align: left">
                {{ nombreLegible(paso) }}
              </td>
              <td style="vertical-align: middle; text-align: left">
                <div
                  v-for="(doc, index) in docsPaso(paso)"
                  :key="`${paso}-${doc.docNum}-${index}`"
                >
                  <strong>#{{ doc.docNum }}</strong>
                  <b-button
                    v-if="doc.docNum"
                    size="is-small"
                    type="is-text"
                    icon-left="copy"
                    pack="far"
                    @click="copyDocNumber(doc.docNum)"
                  />
                </div>
              </td>
              <td style="vertical-align: middle">
                <b-button
                  v-for="(doc, index) in docsImprimibles(paso)"
                  :key="`${paso}-print-${doc.docEntry}-${index}`"
                  size="is-small"
                  icon-left="print"
                  class="ml-1"
                  :loading="estaImprimiendo(paso, doc)"
                  :disabled="estaImprimiendo(paso, doc)"
                  @click="imprimir(paso, doc)"
                >
                  Imprimir
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="hayError" class="mt-3">
          <p class="has-text-danger">{{ mensajeErrorMostrado }}</p>
          <div class="buttons is-centered mt-2">
            <b-button type="is-warning" @click="reintentar"
              >Reintentar</b-button
            >
            <b-button type="is-light" @click="cancelar">Cancelar</b-button>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          v-if="finalizadoAsync"
          label="Cerrar"
          type="is-success"
          @click="closeModalHandle"
        />
        <p v-else class="is-size-7 has-text-grey">
          Procesando, no cerrar esta ventana...
        </p>
      </footer>
    </template>

    <!-- FLUJO LEGACY -->
    <template v-else>
      <header class="modal-card-head">
        <p class="modal-card-title">Confirmación Entrega</p>
        <button type="button" class="delete" @click="closeModalHandle" />
      </header>
      <section class="modal-card-body">
        <div v-if="entregas.length > 0">
          <p>
            Se realiz&oacute; la {{ tipoDocumento }} en SAP <br />
            y se generaron la(s) siguiente(s) número(s) de documento:
          </p>
          <div class="pt-3 columns">
            <div class="column is-8 is-offset-2">
              <p v-for="(item, index) in entregas" :key="`entrega-${index}`">
                <strong>{{ item }}</strong>
              </p>
            </div>
            <div class="column is-2">
              <button @click="copyDocNumberHandle">
                <b-icon icon="copy"></b-icon>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <p>Se realiz&oacute; la {{ tipoDocumento }} en SAP correctamente</p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Cerrar" type="is-success" @click="closeModalHandle" />
        <p>Se cerrará en {{ segundos }}s</p>
      </footer>
    </template>
  </div>
</template>

<script>
import documentoService from '@/services/documento.service'
import { mapGetters, mapState } from 'vuex'

const NOMBRES_PASO = {
  entrega: 'Entrega',
  factura: 'Factura',
  transferencia: 'Transferencia de stock',
  finalizado: 'Finalizacion del despacho'
}

const PASO_UI_POR_TIPO = {
  ENTREGARPEDIDO: 'entrega',
  ENTREGA: 'entrega',
  FACTURARPEDIDO: 'factura',
  FACTURA: 'factura',
  TRANSFERIRSTOCK: 'transferencia',
  TRANSFERENCIASTOCK: 'transferencia',
  TRANSFERENCIA: 'transferencia',
  FINALIZARDESPACHO: 'finalizado',
  FINALIZADO: 'finalizado'
}

const PASOS_UI_ORDEN = ['entrega', 'factura', 'transferencia', 'finalizado']

const TIPO_IMPRESION_POR_PASO = {
  entrega: 'entrega',
  factura: 'factura',
  transferencia: 'transferencia'
}

export default {
  name: 'CierreModal',
  props: {
    entregas: {
      type: Array,
      required: true
    },
    esSolicitudTraslado: {
      type: Boolean,
      default: false
    },
    pedidoId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      segundos: 30,
      entrega: '',
      timeout: null,
      imprimiendoDocs: {}
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    ...mapState('despacho', [
      'pasos',
      'estadoPasos',
      'docsPorPaso',
      'pedidos',
      'mensajeError',
      'errorAsync',
      'finalizadoAsync'
    ]),
    esAsync() {
      return Array.isArray(this.pasos) && this.pasos.length > 0
    },
    hayError() {
      return (
        Boolean(this.mensajeErrorMostrado) ||
        Object.values(this.estadoPasos).some((e) => e === 'error')
      )
    },
    pasosVisibles() {
      if (!Array.isArray(this.pasos) || this.pasos.length === 0) {
        return [...PASOS_UI_ORDEN]
      }
      const vistos = {}
      const ordenados = []
      this.pasos.forEach((paso) => {
        const ui = this.normalizarPasoUi(paso)
        if (!ui || vistos[ui]) return
        vistos[ui] = true
        ordenados.push(ui)
      })
      if (!vistos.finalizado) {
        ordenados.push('finalizado')
      }
      return ordenados
    },
    mensajeErrorMostrado() {
      return this.errorAsync?.mensajeError || this.mensajeError || ''
    },
    tipoDocumento() {
      if (this.esSolicitudTraslado) {
        return 'transferencia de stock'
      }
      return 'entrega'
    },
    esTipoVentaGuiaDespacho() {
      const tipoVenta = String(this.pedidos?.[0]?.tipoVenta ?? '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
      return tipoVenta === 'guiadespacho'
    }
  },
  watch: {
    segundos() {
      if (this.segundos === 0) {
        this.$emit('close')
      }
    }
  },
  mounted() {
    if (!this.esAsync) {
      this.timeout = setInterval(() => this.segundos--, 1000)
      this.entrega = this.entregas[0] ?? ''
    }
  },
  beforeDestroy() {
    clearInterval(this.timeout)
  },
  methods: {
    closeModalHandle() {
      this.$emit('close')
    },
    nombreLegible(tipo) {
      return NOMBRES_PASO[tipo] ?? tipo
    },
    normalizarPasoUi(tipo) {
      if (!tipo) return null
      return PASO_UI_POR_TIPO[String(tipo).trim().toUpperCase()] ?? null
    },
    docsPaso(paso) {
      return Array.isArray(this.docsPorPaso[paso]) ? this.docsPorPaso[paso] : []
    },
    esFacturaDeudor(doc) {
      const texto = String(doc?.tipo ?? doc?.comments ?? '')
        .trim()
        .toLowerCase()
      return texto.includes('deudor')
    },
    puedeImprimirDoc(paso, doc) {
      if (this.bodega?.facturarDesdeMopi !== true) return false
      if (!doc?.docEntry) return false
      if (paso === 'factura') return true
      if (paso === 'entrega') return this.esTipoVentaGuiaDespacho
      if (paso === 'transferencia') return false
      return false
    },
    docsImprimibles(paso) {
      if (this.estadoPasos[paso] !== 'ok') return []
      const imprimibles = this.docsPaso(paso).filter((doc) =>
        this.puedeImprimirDoc(paso, doc)
      )

      if (paso !== 'factura' || imprimibles.length <= 1) {
        return imprimibles
      }

      const facturaDeudor = imprimibles.find((doc) => this.esFacturaDeudor(doc))
      return [facturaDeudor ?? imprimibles[0]]
    },
    resolverTipoImpresion(paso, doc) {
      if (paso === 'factura') {
        return TIPO_IMPRESION_POR_PASO.factura
      }

      if (paso === 'entrega') {
        return TIPO_IMPRESION_POR_PASO.entrega
      }

      if (paso === 'transferencia') {
        return TIPO_IMPRESION_POR_PASO.transferencia
      }

      return TIPO_IMPRESION_POR_PASO[paso]
    },
    claveImpresion(paso, doc) {
      return `${paso}-${doc?.docEntry}`
    },
    estaImprimiendo(paso, doc) {
      return Boolean(this.imprimiendoDocs[this.claveImpresion(paso, doc)])
    },
    async imprimir(paso, doc) {
      const tipo = this.resolverTipoImpresion(paso, doc)
      if (!tipo || !doc?.docEntry) {
        return
      }

      const clave = this.claveImpresion(paso, doc)
      if (this.imprimiendoDocs[clave]) {
        return
      }

      this.$set(this.imprimiendoDocs, clave, true)
      try {
        await documentoService.imprimirDocumentoSap(tipo, doc.docEntry)
      } catch (error) {
        const responseData = error?.response?.data
        let detalleError =
          error?.mensajeDetallado || error?.response?.data?.error || ''

        if (!detalleError && typeof responseData === 'string') {
          try {
            const responseDataParseada = JSON.parse(responseData)
            detalleError =
              responseDataParseada?.error || responseDataParseada?.Error || ''
          } catch (e) {
            detalleError = responseData.trim()
          }
        } else if (!detalleError) {
          detalleError = responseData?.error || responseData?.Error || ''
        }

        detalleError = detalleError || error?.message
        const mensaje = detalleError
          ? `Error al abrir el documento para impresión: ${detalleError}`
          : 'Error al abrir el documento para impresión'
        this.notificarError(mensaje)
      } finally {
        this.$delete(this.imprimiendoDocs, clave)
      }
    },
    reintentar() {
      if (this.pedidoId) {
        this.$store.dispatch('despacho/reintentarDespacho', this.pedidoId)
      }
    },
    cancelar() {
      if (this.pedidoId) {
        localStorage.removeItem(`entrega_${this.pedidoId}`)
      }
      this.$store.dispatch('despacho/cerrarHubConnection')
      this.$emit('close')
    },
    async copyDocNumber(valor) {
      try {
        await navigator.clipboard.writeText(String(valor))
        this.notificarAccionCompletada('Numero SAP copiado')
      } catch ($e) {
        this.notificarError('Error al copiar al portapapeles')
      }
    },
    copyDocNumberHandle() {
      this.copyDocNumber(this.entrega)
    }
  }
}
</script>
